import { Col, Divider, Form, Row } from 'antd';
import { Rule } from 'antd/es/form';
import { LINK_URL } from 'infrastructure/config/CONSTANTS';
import { openErrorNoti } from 'presentation/components/Notification';
import { FormCheckBox } from 'presentation/components/form/FormCheckBox.component';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormSelect } from 'presentation/components/form/FormSelect.component';
import { FormTextArea } from 'presentation/components/form/FormTextArea.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { NUMBER_MULTIPLE_DEPOSIT } from '..';
import { StepProps } from '../props/StepProps';
import { ButtonList } from './ButtonList';
import { ItemBox } from './ItemBox';

export const PurchaseStepThree = ({ data, masterData, setIsChange, ...props }: StepProps) => {
    const [btnDisable, setBtnDisable] = useState<boolean>(true);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [finalPayment, setFinalPayment] = useState<any>(0);
    const [finalPaymentCashm, setFinalPaymentCashm] = useState<any>(0);
    const [showOrther, setShowOrther] = useState<boolean>(false);

    useEffect(() => {
        props.scrollTop && props.scrollTop();
    }, []);

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                ...data,
                deposit: data.deposit || '1',
                confirm_cic: data?.confirm_cic != '10' ? undefined : data?.confirm_cic,
                accept_term: data?.accept_term != '10' ? undefined : data?.accept_term,
            });
            onChangeForm();
        }
        const deposit = commonHelpers.toNumberOnly(data?.deposit) || 1;
        const totalPrice = commonHelpers.toNumberOnly(data?.totalPrice) || commonHelpers.toNumberOnly(data?.purchasePriceExcludingBrokerageFee) + commonHelpers.toNumberOnly(data?.brokerageFeeSpecificTreat);
        const finalPayment = totalPrice - deposit;
        const finalPaymentCashm = data?.personalFunds;
        setFinalPayment(finalPayment);
        setFinalPaymentCashm(finalPaymentCashm);
        setShowOrther(data?.dealPurposeType == 99);
    }, [data]);

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                console.log(err);
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    const depositNotZeroValidator: Rule = {
    // カスタム validator
    validator: (_rule, value) => {
        const raw = value ?? '';
        const n = Number(String(raw).replace(/[^0-9.-]/g, ''));
        if (Number.isNaN(n)) {
        return Promise.reject(new Error('数値で入力してください'));
        }
        if (n === 0) {
        return Promise.reject(new Error('0 は許可されません'));
        }
        if (n < 0) {
        return Promise.reject(new Error('0より大きい数を入力してください'));
        }
        return Promise.resolve();
    },
    };

    const submitNext = async () => {
        try {
            dispatch(startFetching());
            const depositValue = commonHelpers.toNumberOnly(form.getFieldValue('deposit')) ?? 0;
            const depositNumber =
                (isNaN(Number(depositValue)) ? 0 : Number(depositValue)) * NUMBER_MULTIPLE_DEPOSIT;
            const payload = {
                ...form.getFieldsValue(),
                dealPurposeOthers: showOrther ? form.getFieldValue('dealPurposeOthers') : '',
                procedureId: data?.procedureId,
                purchaseOfferId: data?.purchaseOfferId,
                listed_property_id: data?.listedPropertyId,
                purchasePrice: data?.purchasePrice,
                loanUseStatus: data?.loanUseStatus,
                deposit: depositNumber,
                finalPayment: finalPayment,
                finalPaymentCash: finalPaymentCashm,
                loanAmount: subtract(data?.purchasePriceExcludingBrokerageFee, data?.personalFunds),
                agreementOpeDiv01: 10,
                agreementOpeDiv02: 10,
            };
            const response = await props.purchaseUseCase.savePurchaseIndividualStep3(payload);
            if (response) {
                const param = {
                    listedPropertyId: data?.listedPropertyId,
                    purchasePrice: data?.purchasePrice,
                    purchaseOfferId: data?.purchaseOfferId,
                    procedureId: data?.procedureId,
                    loanUseStatus: data?.loanUseStatus,
                };
                navigate(
                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_015_02}?${commonHelpers.generateQueryString(param)}`,
                );
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const redirectCU05802 = () => {
        const param = {
            purchasePrice: data?.purchasePrice,
            purchaseOfferId: data?.purchaseOfferId,
            procedureId: data?.procedureId,
            loanUseStatus: data?.loanUseStatus,
        };
        navigate(
            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_058_02}/${data?.simId}?${commonHelpers.generateQueryString(param)}`,
        );
    };

    useEffect(() => {
        props.scrollTop && props.scrollTop();
    }, []);

    const changeBtnDisable = (isError: any) => {
        if (isError) {
            setBtnDisable(true);
        } else {
            onChangeForm();
        }
    };

    const subtract = (a?: any, b?: any) => {
        const aNumber = isNaN(Number(a)) ? 0 : Number(a);
        const bNumber = isNaN(Number(b)) ? 0 : Number(b);
        return aNumber - bNumber;
    };

    return (
        <>
            <Form
                form={form}
                onValuesChange={() => {
                    onChangeForm();
                    setIsChange && setIsChange(true);
                }}
                onFinish={submitNext}
            >
                <Row className="min-w-min">
                    <div className="w-full mb-[32px]">
                        <Row gutter={[0, 12]} className="mt-[12px]">
                            <Col span={24} className="pl-[12px]">
                                ご契約日時等についての詳細や、仲介手数料等の支払方法の詳細につきましては、当社スタッフより3営業日以内にメールにてご連絡差し上げます。
                            </Col>
                            <Col span={12}  className="ml-[12px]">
                                <FormCheckBox
                                    name="accept_description"
                                    required
                                    options={[
                                        {
                                            value: '10',
                                            label: '理解しました',
                                        },
                                    ]}
                                    showErrorMessage={false}
                                    className="mb-0"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="契約予定日"
                                    value={data?.scheduleContactDate}
                                    type="date"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="決済予定日"
                                    value={data?.scheduleFinalPaymentDate}
                                    type="date"
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="w-full mb-[32px]">
                        <span className="content-step-form heading-step-form">売買代金</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]} className="mt-[12px]">
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="購入価格"
                                    value={data?.purchasePriceExcludingBrokerageFee}
                                    type="number"
                                    suffix="円"
                                    className="mb-[12px]"
                                />
                            </Col>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="仲介手数料"
                                    value={data?.brokerageFeeSpecificTreat}
                                    type="number"
                                    suffix="円"
                                    formatNumber
                                    className="mb-[12px]"
                                    defaultvalue={0}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="代金総額"
                                    value={data?.totalPrice}
                                    type="number"
                                    suffix="円"
                                    className="mb-[12px]"
                                />
                            </Col>
                            <Col span={12} className="pr-[12px]">
                                <ItemBox
                                    label="自己資金"
                                    value={data?.personalFunds}
                                    type="number"
                                    suffix="円"
                                    className="mb-[12px]"
                                />
                            </Col>
                        </Row>
                    </div>
                    {data?.loanUseStatus != '10' && (
                        <div className="w-full mb-[32px]">
                            <span className="content-step-form heading-step-form">代金支払内訳</span>
                            <Divider className="mb-[24px] my-1" />
                            <Row className="my-[12px]">
                                <Col span={12} className="pr-[12px]">
                                    <ItemBox
                                        label="現金"
                                        value={data?.personalFunds}
                                        type="number"
                                        suffix="円"
                                        suffixLinkText="修正"
                                        onClickLink={redirectCU05802}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-[12px]">
                                <Col span={12} className="pr-[12px]">
                                    <ItemBox
                                        label="ローン金額"
                                        value={subtract(data?.purchasePriceExcludingBrokerageFee, data?.personalFunds)}
                                        type="number"
                                        suffix="円"
                                        suffixLinkText="修正"
                                        onClickLink={redirectCU05802}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12} className="pr-[12px]">
                                    <ItemBox
                                        label="ローン期間"
                                        value={`${data?.repaymentPeriod ?? '0'}年`}
                                        type="text"
                                    />
                                </Col>
                                <Col span={12} className="pr-[12px]">
                                    <ItemBox
                                        label="ローン金利"
                                        value={`${commonHelpers.formatMoney(data?.interestRate ?? '0')}％`}
                                        type="text"
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}

                    <div className="w-full mb-[32px]">
                        <span className="content-step-form heading-step-form">取引目的</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]} className="my-[12px]">
                            <Col span={24}>
                                <FormSelect
                                    options={
                                        masterData?.[
                                        MASTER_CATEGORY_LIST.DEAL_PURPOSE_TYPE_CLASSIFICATION
                                        ]
                                    }
                                    label="取引目的"
                                    required
                                    name="dealPurposeType"
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(value) => {
                                        setShowOrther(value == 99);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]} className="my-[12px]">
                            <Col span={24}>
                                <FormTextArea
                                    label="その他目的"
                                    name="dealPurposeOthers"
                                    currentForm={form}
                                    required={showOrther}
                                    disabled={!showOrther}
                                    maxLength={1000}
                                    size={'large'}
                                    cols={5}
                                    labelClassName="content-step-form label-step-form"
                                    onValidateError={changeBtnDisable}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={24}>
                                <FormInput
                                    label="キャンペーンコード（任意）"
                                    name="campaignCode"
                                    maxLength={20}
                                    size={'large'}
                                    onlyRomanji={true}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                    </div>
                    <ButtonList {...props} next={submitNext} disable={btnDisable} />
                </Row>
            </Form>
        </>
    );
};
